import { API } from '../api'
import { Collector, CollectorsResponse } from './interface'

export const fetchAll = async (
  filtros: Record<string, any>
): Promise<{
  items: Collector[]
  total: number
}> => {
  try {
    const {
      agrupamento,
      dataLiberacaoFinal,
      dataLiberacaoInicial,
      idsEmpregadores,
      idsOperadoras,
      idsUnidades,
      paginaAtual,
      situacoes,
      tamanhoPagina,
      termo
    } = filtros

    const params = new URLSearchParams()
    idsOperadoras?.forEach(id => params.append('idsOperadoras', id))
    idsUnidades?.forEach(id => params.append('idsUnidades', id))
    situacoes?.forEach(id => params.append('situacoes', id))
    params.append('codigo', agrupamento || '')
    params.append('dataLiberacaoFinal', dataLiberacaoFinal)
    params.append('dataLiberacaoInicial', dataLiberacaoInicial)
    params.append('idsEmpregadores', idsEmpregadores || '')
    params.append('paginaAtual', paginaAtual)
    params.append('tamanhoPagina', tamanhoPagina)
    params.append('termo', termo || '')

    const response = await API.get<CollectorsResponse>(
      '/logistica/agrupamento/coletas',
      params
    )
    const results: Collector[] = response.content.agrupamentos ?? []

    const total = response.content.totalItems ?? 0
    return { items: results, total }
  } catch (error) {
    console.error('Erro ao buscar coletas:', error)
    return { items: [], total: 0 }
  }
}
